import React from 'react';
import ErrorPage from 'next/error';
import { useRouter } from 'next/router';
import { RaisinContainer, Typography } from '@raisin/components-lib';
import { getLocale } from '@raisin/cp-utils';
import { Alert, FlagsGrid, Hero } from './components';
import { alertText, heroData } from './data';

export const CountrySelector = () => {
  const router = useRouter();
  const locale = getLocale(router.locale)?.intlFormat;

  if (locale !== 'en') {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <>
      <Hero {...heroData} />
      <RaisinContainer>
        <Alert mode="information">
          <Typography variant="body1">{alertText}</Typography>
        </Alert>
        <FlagsGrid />
      </RaisinContainer>
    </>
  );
};
